import e, { Component as t } from "react";
import r from "../../../../node_modules/classnames/index.js";
import "../../../utils/DomHandler.js";
import n from "../../../utils/ObjectUtils.js";
import { FirstPageLink as o } from "./FirstPageLink.js";
import { NextPageLink as a } from "./NextPageLink.js";
import { PrevPageLink as s } from "./PrevPageLink.js";
import { LastPageLink as i } from "./LastPageLink.js";
import { PageLinks as p } from "./PageLinks.js";
import { RowsPerPageDropdown as l } from "./RowsPerPageDropdown.js";
import { CurrentPageReport as u } from "./CurrentPageReport.js";
import { JumpToPageInput as g } from "./JumpToPageInput.js";
function c(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function h(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function f(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function P(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function m(e) {
  return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function y(e, t) {
  return (y = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var d = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && y(e, t);
  }(b, t);
  var d,
    k,
    v,
    w = (d = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = m(b);
      if (d) {
        var n = m(this).constructor;
        t = Reflect.construct(r, arguments, n);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : h(this);
    });
  function b() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, b), e = w.apply(this, arguments), P(h(e), "isRowChanged", void 0), P(h(e), "changePage", function (t, r) {
      var n = e.getPageCount(),
        o = Math.floor(t / r);
      o >= 0 && o < n && e.props.onPageChange && e.props.onPageChange({
        first: t,
        rows: r,
        page: o,
        pageCount: n
      });
    }), P(h(e), "getTemplateType", function () {
      switch (e.props.template) {
        case "Regular":
          return {
            template: "CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown",
            type: "regular"
          };
        case "Compact":
          return {
            template: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
            type: "compact"
          };
        case "CompactFirstLastPage":
          return {
            template: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink NextPageLink LastPageLink",
            type: "compact-first-last-page"
          };
      }
      return null;
    }), P(h(e), "changePageToFirst", function (t) {
      e.changePage(0, e.props.rows), t.preventDefault();
    }), P(h(e), "changePageToPrev", function (t) {
      e.changePage(e.props.first - e.props.rows, e.props.rows), t.preventDefault();
    }), P(h(e), "onPageLinkClick", function (t) {
      e.changePage((t.value - 1) * e.props.rows, e.props.rows);
    }), P(h(e), "changePageToNext", function (t) {
      e.changePage(e.props.first + e.props.rows, e.props.rows), t.preventDefault();
    }), P(h(e), "changePageToLast", function (t) {
      e.changePage((e.getPageCount() - 1) * e.props.rows, e.props.rows), t.preventDefault();
    }), P(h(e), "onRowsChange", function (t) {
      var r = Number(t.value);
      e.isRowChanged = r !== e.props.rows, e.changePage(0, r);
    }), e;
  }
  return k = [{
    key: "isFirstPage",
    value: function value() {
      return 0 === this.getPage();
    }
  }, {
    key: "isLastPage",
    value: function value() {
      return this.getPage() === this.getPageCount() - 1;
    }
  }, {
    key: "getPageCount",
    value: function value() {
      return Math.ceil(this.props.totalRecords / this.props.rows);
    }
  }, {
    key: "calculatePageLinkBoundaries",
    value: function value() {
      var e = this.getPageCount() - 1,
        t = Math.min(this.props.pageLinkSize, e),
        r = Math.max(0, Math.ceil(this.getPage() - t / 2)),
        n = Math.min(e - 1, r + t - 1),
        o = this.props.pageLinkSize - (n - r + 1);
      return [r = Math.max(0, r - o), n];
    }
  }, {
    key: "updatePageLinks",
    value: function value() {
      for (var e = [], t = this.calculatePageLinkBoundaries(), r = t[0], n = t[1], o = r; o <= n; o++) e.push(o + 1);
      return e;
    }
  }, {
    key: "getPage",
    value: function value() {
      return Math.floor(this.props.first / this.props.rows);
    }
  }, {
    key: "empty",
    value: function value() {
      return 0 === this.getPageCount();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this.props.rows === e.rows || this.isRowChanged ? this.getPage() > 0 && e.totalRecords !== this.props.totalRecords && this.props.first >= this.props.totalRecords && this.changePage((this.getPageCount() - 1) * this.props.rows, this.props.rows) : this.changePage(0, this.props.rows), this.isRowChanged = !1;
    }
  }, {
    key: "renderElement",
    value: function value(t, r) {
      var n;
      switch (t) {
        case "FirstPageLink":
          n = e.createElement(o, {
            key: t,
            onClick: this.changePageToFirst,
            disabled: this.isFirstPage() || this.empty(),
            template: r
          });
          break;
        case "PrevPageLink":
          n = e.createElement(s, {
            key: t,
            onClick: this.changePageToPrev,
            disabled: this.isFirstPage() || this.empty(),
            template: r
          });
          break;
        case "NextPageLink":
          n = e.createElement(a, {
            key: t,
            onClick: this.changePageToNext,
            disabled: this.isLastPage() || this.empty(),
            template: r
          });
          break;
        case "LastPageLink":
          n = e.createElement(i, {
            key: t,
            onClick: this.changePageToLast,
            disabled: this.isLastPage() || this.empty(),
            template: r
          });
          break;
        case "PageLinks":
          n = e.createElement(p, {
            key: t,
            value: this.updatePageLinks(),
            page: this.getPage(),
            rows: this.props.rows,
            pageCount: this.getPageCount(),
            onClick: this.onPageLinkClick,
            template: r
          });
          break;
        case "RowsPerPageDropdown":
          n = e.createElement(l, {
            key: t,
            value: this.props.rows,
            page: this.getPage(),
            pageCount: this.getPageCount(),
            totalRecords: this.props.totalRecords,
            options: this.props.rowsPerPageOptions,
            onChange: this.onRowsChange,
            appendTo: this.props.dropdownAppendTo,
            template: r,
            disabled: this.empty()
          });
          break;
        case "CurrentPageReport":
          n = e.createElement(u, {
            ReportTemplate: this.props.CurrentPageReportTemplate,
            key: t,
            page: this.getPage(),
            pageCount: this.getPageCount(),
            first: this.props.first,
            rows: this.props.rows,
            totalRecords: this.props.totalRecords,
            template: r
          });
          break;
        case "JumpToPageInput":
          n = e.createElement(g, {
            key: t,
            rows: this.props.rows,
            page: this.getPage(),
            pageCount: this.getPageCount(),
            onChange: this.changePage,
            disabled: this.empty(),
            template: r
          });
          break;
        default:
          n = null;
      }
      return n;
    }
  }, {
    key: "renderElements",
    value: function value() {
      var e,
        t,
        r = this,
        n = this.props.template;
      return n ? "object" == typeof n ? n.layout ? n.layout.split(" ").map(function (e) {
        var t = e.trim();
        return r.renderElement(t, n[t]);
      }) : Object.entries(n).map(function (e) {
        var t = function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            var r,
              n,
              o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != o) {
              var a = [],
                s = !0,
                i = !1;
              try {
                for (o = o.call(e); !(s = (r = o.next()).done) && (a.push(r.value), !t || a.length !== t); s = !0);
              } catch (e) {
                i = !0, n = e;
              } finally {
                try {
                  s || null == o.return || o.return();
                } finally {
                  if (i) throw n;
                }
              }
              return a;
            }
          }(e, 2) || function (e, t) {
            if (e) {
              if ("string" == typeof e) return c(e, t);
              var r = Object.prototype.toString.call(e).slice(8, -1);
              if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
              if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return c(e, t);
            }
          }(e, 2) || function () {
            throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }(),
          n = t[0],
          o = t[1];
        return r.renderElement(n, o);
      }) : (n = null !== (t = null === (e = this.getTemplateType()) || void 0 === e ? void 0 : e.template) && void 0 !== t ? t : n).split(" ").map(function (e) {
        return r.renderElement(e.trim());
      }) : null;
    }
  }, {
    key: "render",
    value: function value() {
      if (!this.props.alwaysShow && 1 === this.getPageCount()) return null;
      var t,
        o,
        a = r("kaseya-ui-paginator", this.props.className, "paginator--".concat(null !== (o = null === (t = this.getTemplateType()) || void 0 === t ? void 0 : t.type) && void 0 !== o ? o : "page")),
        s = n.getJSXElement(this.props.leftContent, this.props),
        i = n.getJSXElement(this.props.rightContent, this.props),
        p = this.renderElements(),
        l = s && e.createElement("div", {
          className: "paginator__left-content"
        }, s),
        u = i && e.createElement("div", {
          className: "paginator__right-content"
        }, i);
      return e.createElement("div", {
        className: a,
        style: this.props.style
      }, l, p, u);
    }
  }], f(b.prototype, k), v && f(b, v), b;
}(t);
P(d, "defaultProps", {
  totalRecords: 0,
  rows: 0,
  first: 0,
  pageLinkSize: 5,
  rowsPerPageOptions: null,
  alwaysShow: !0,
  style: null,
  className: null,
  template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  onPageChange: null,
  leftContent: null,
  rightContent: null,
  dropdownAppendTo: null
});
export { d as Paginator };